import checkLastRestImage from './checkLastRestImage';

/**
 *
 * @param {number} index
 * @param {number} paginationSize
 * @returns {boolean}
 */
export default (index, paginationSize) => paginationSize && checkLastRestImage(index);
